import React from 'react'

export const GameControllerIllustration: React.FC = () => {
  return (
    <svg
      width="400"
      height="250"
      viewBox="0 0 400 250"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(50, 30)">
        {/* 游戏控制器 */}
        <rect x="60" y="50" width="180" height="100" rx="50" fill="#4E6BFE" />
        <circle cx="100" cy="100" r="25" fill="#BEDCFE" />
        <circle cx="200" cy="100" r="25" fill="#BEDCFE" />
        <rect x="140" y="70" width="20" height="10" rx="5" fill="#BEDCFE" />
        <rect x="140" y="90" width="20" height="10" rx="5" fill="#BEDCFE" />
        <rect x="130" y="80" width="10" height="20" rx="5" fill="#BEDCFE" />
        <rect x="160" y="80" width="10" height="20" rx="5" fill="#BEDCFE" />

        {/* 包裹和箭头 */}
        <rect x="10" y="20" width="60" height="60" fill="#E8E8E8" />
        <line x1="10" y1="40" x2="70" y2="40" stroke="#CCC" strokeWidth="2" />
        <rect x="25" y="10" width="30" height="10" fill="#FFC043" />

        <path
          d="M80,50 L100,30 L120,50"
          stroke="#FFC043"
          strokeWidth="3"
          fill="none"
        />
        <path
          d="M100,30 L100,60"
          stroke="#FFC043"
          strokeWidth="3"
          fill="none"
        />

        <rect x="250" y="20" width="60" height="60" fill="#E8E8E8" />
        <line x1="250" y1="40" x2="310" y2="40" stroke="#CCC" strokeWidth="2" />
        <rect x="265" y="10" width="30" height="10" fill="#FFC043" />

        {/* 用户头像 */}
        <circle cx="150" y="170" r="30" fill="#BEDCFE" />
        <circle cx="150" y="150" r="12" fill="#4E6BFE" />
        <rect x="130" y="170" width="40" height="25" rx="10" fill="#4E6BFE" />
      </g>
    </svg>
  )
}

export default GameControllerIllustration
